// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3pqej","primary":"styles_primary__2Afkd","secondary":"styles_secondary__1duz8"};